//
// Copyright (c) 2019-Present Syncari - All rights reserved.
//

import AppConstants from 'utils/AppConstants';

import {
  CustomActionPythonPayload,
  CustomActionPythonServerPayload,
  CustomActionPythonSyncAIGeneratedPayload,
  CustomActionPythonSyncAIGeneratedServerPayload,
  InputVariablePayload,
  InputVariableServerPayload,
} from './types';

/**
 * Transform InputVariable from server format (boolean) to client format (string)
 */
export const transformInputVariable = (variable: InputVariableServerPayload): InputVariablePayload => ({
  ...variable,
  multivalued:
    variable.multivalued === true || variable.multivalued === (AppConstants.TRUE as any)
      ? AppConstants.TRUE
      : AppConstants.FALSE,
  required:
    variable.required === true || variable.required === (AppConstants.TRUE as any)
      ? AppConstants.TRUE
      : AppConstants.FALSE,
});

export const transformInputVariableToServerPayload = (variable: InputVariablePayload): InputVariableServerPayload => ({
  ...variable,
  multivalued: String(variable.multivalued).toLowerCase() === AppConstants.TRUE,
  required: String(variable.required).toLowerCase() === AppConstants.TRUE,
});

/**
 * Transform CustomActionPython from server format to client format
 * Converts boolean values in inputVariables to strings for form handling
 */
export const transformToCustomActionPython = (data: CustomActionPythonServerPayload): CustomActionPythonPayload => ({
  ...data,
  inputVariables: data?.inputVariables?.map(transformInputVariable),
});

export const transformToCustomActionPythonSyncAI = (
  data: CustomActionPythonSyncAIGeneratedServerPayload
): CustomActionPythonSyncAIGeneratedPayload => ({
  ...data,
  inputVariables: data?.inputVariables?.map(transformInputVariable),
});

/**
 * Transform CustomActionPython from API format to form format
 * Maps server field names to form field names and structures data for the wizard
 */
export const transformToCustomActionPythonFormData = (data: any): any => {
  // Transform inputVariables if they exist
  const variables =
    data?.inputVariables?.map((variable: any) => ({
      ...variable,
      multivalued:
        variable.multivalued === true || variable.multivalued === AppConstants.TRUE
          ? AppConstants.TRUE
          : AppConstants.FALSE,
      required:
        variable.required === true || variable.required === AppConstants.TRUE ? AppConstants.TRUE : AppConstants.FALSE,
    })) || [];

  return {
    dataFormatType: 'form', // Required for Skull to recognize this as form data
    id: data?.id,
    displayName: data?.displayName || '',
    apiName: data?.apiName || '',
    description: data?.description || '',
    basicHelpText: data?.basicHelpText || data?.helpText || '',
    helpLink: data?.helpLink || '',
    tags: data?.tags || [],
    iconPath: data?.iconPath || '',
    pythonCode: data?.code || '',
    pythonRequirements: data?.requirements || '',
    variables: variables,
    tests: data?.tests || [],
    actionConfiguration: { method: 'python' },
  };
};
